export const ModalNames = {
  STAKE: 'STAKE',
  STAKE_MORE: 'STAKE_MORE',
  WITHDRAW: 'WITHDRAW',
  EXTEND: 'EXTEND',
  CLAIM: 'CLAIM',
} as const;

export type ModalName = keyof typeof ModalNames;

export enum ModeTokenAmount {
  STAKE_MORE = 'stake_more',
  KEEP_CURRENT = 'keep_current',
}

export enum ModeLockedPeriod {
  EXTEND = 'extend',
  KEEP_CURRENT = 'keep_current',
}
